export default "__VITE_ASSET__834c9a59__"